module.exports = __webpack_public_path__ + "img/sendclean.0f1058f9.png";